import type { Status } from './api';

/**
 * Ist das Konto mit Claude verbunden? Ab dem ersten Aufruf ja, auch ohne Lauf.
 * Die alte Regel („ein Lauf diesen Monat") bleibt als Oder daneben: vor dem
 * Deploy fehlt das Feld ganz, und ein Lauf beweist die Verbindung ohnehin.
 */
export const istVerbunden = (s: Status | null | undefined): boolean =>
  !!s?.erster_aufruf_at || (s?.balance?.month?.runs ?? 0) > 0;
